export default function MerchantsOverviewController(
  $state,
  $stateParams,
  merchantService,
  countryService,
  externalSourcesService,
  MERCHANT_PRODUCTS
) {
  var vm = this;

  vm.isLoading = false;
  vm.total = 0;
  vm.maxSize = 5;
  vm.currentPage = 0;

  vm.countries = [];
  vm.externalPartnerSources = [];
  vm.externalPartnerSubSources = [];
  vm.merchants = null;
  vm.merchantId = null;

  vm.sortByDirection = {
    ASC: 'Asc',
    DESC: 'Desc',
  };

  vm.sortBy = {
    NAME: {
      value: 'name',
      direction: '',
      show: false,
    },
    UPDATED_AT: {
      value: 'dateModified',
      direction: vm.sortByDirection.DESC,
      show: true,
    },
    CREATED_AT: {
      value: 'dateCreated',
      direction: '',
      show: false,
    },
  };

  vm.filter = {
    countryId: null,
    testOnly: false,
    offset: 0,
    limit: 50,
    productIds: null,
    sortBy: vm.sortBy.UPDATED_AT.value + vm.sortBy.UPDATED_AT.direction,
  };

  vm.filterByProduct = [];
  vm.merchantProducts = [
    {
      id: MERCHANT_PRODUCTS.FREE_PLUS,
      name: 'Free+',
    },
    {
      id: MERCHANT_PRODUCTS.MERCHANT_CENTER_BASIC,
      name: 'Basic',
    },
    {
      id: MERCHANT_PRODUCTS.PROFESSIONAL_WEB,
      name: 'Professional',
    },
    {
      id: MERCHANT_PRODUCTS.PREMIUM_MERCHANT,
      name: 'Premium',
    },
    {
      id: MERCHANT_PRODUCTS.LISTING_NON_PARTNER_RESTAURANT,
      name: 'Non Partner',
    },
    {
      id: 0,
      name: 'Offline',
    },
    {
      id: MERCHANT_PRODUCTS.PROSPECT,
      name: 'Prospect',
    },
    {
      id: MERCHANT_PRODUCTS.BOOK,
      name: 'Book',
    },
    {
      id: MERCHANT_PRODUCTS.QRB,
      name: 'QfR Pro',
    },
    {
      id: MERCHANT_PRODUCTS.EXTERNAL_PARTNER,
      name: 'Integration Partner',
    },
  ];

  vm.getMerchants = getMerchants;
  vm.getMerchantsBySearchTerm = getMerchantsBySearchTerm;
  vm.calculatePagination = calculatePagination;
  vm.getMerchantsByOffset = getMerchantsByOffset;
  vm.pageChanged = pageChanged;
  vm.goToMerchantOverview = goToMerchantOverview;
  vm.toggleSorting = toggleSorting;

  vm.init = init;

  init();

  function init() {
    initMerchantProductCheckboxes();
    initCountryFilter();
    initTestOnlyFilter();
    getCountries();
    getAllExternalSources();
  }

  function getCountries() {
    vm.isLoading = true;
    countryService
      .getAllCountries()
      .then(function(res) {
        if (res && res.data) {
          vm.countries = res.data;
        }
      })
      .finally(function() {
        vm.isLoading = false;
        vm.getMerchants();
      });
  }

  function getAllExternalSources() {
    return externalSourcesService.getAllExternalSources().then(function(res) {
      if (res && res.data) {
        vm.externalPartnerSources = res.data.sources;
        vm.externalPartnerSubSources = res.data.subSources;
      }
    });
  }

  function initMerchantProductCheckboxes() {
    if ($stateParams) {
      const allProductsSelected = Array.isArray($stateParams.productIds) && $stateParams.productIds.length === vm.merchantProducts.length;
      angular.forEach(vm.merchantProducts, function(merchantProduct) {
        if (Array.isArray($stateParams.productIds)) {
          vm.filterByProduct[merchantProduct.id] = allProductsSelected ? false : $stateParams.productIds.includes(`${merchantProduct.id}`);
        } else {
          vm.filterByProduct[merchantProduct.id] = allProductsSelected ? false : $stateParams.productIds === `${merchantProduct.id}`;
        }
      });
    }
  }

  function initCountryFilter() {
    if ($stateParams) {
      vm.filter.countryId = $stateParams.countryId;
    }
  }

  function initTestOnlyFilter() {
    if ($stateParams) {
      vm.filter.testOnly = $stateParams.testOnly === 'true';
    }
  }

  function setMerchantListDefaultValues() {
    vm.total = 0;
    vm.filter.offset = 0;
    vm.currentPage = 0;
  }

  function getMerchants() {
    setMerchantListDefaultValues();
    getMerchantsByOffset();
  }

  function getMerchantsByOffset() {
    vm.merchants = [];
    const activeProductIds = vm.merchantProducts.filter(function(merchantProduct) {
      return vm.filterByProduct[merchantProduct.id];
    });

    vm.filter.productIds = (activeProductIds.length ? activeProductIds : vm.merchantProducts).map(function(merchantProduct) {
      return merchantProduct.id;
    });

    vm.filter.sourceId = activeProductIds.find(product => product.id === MERCHANT_PRODUCTS.EXTERNAL_PARTNER) ? vm.filter.sourceId : null;

    vm.isLoading = true;
    merchantService
      .getMerchants(vm.filter)
      .then(function(res) {
        if (res && res.data && res.data.merchants) {
          vm.total = res.data.total;
          vm.merchants = res.data.merchants;
        }
      })
      .finally(function() {
        vm.isLoading = false;
      });

    $state.go(
      'app.merchants',
      {
        productIds: vm.filter.productIds,
        countryId: vm.filter.countryId,
        testOnly: vm.filter.testOnly,
      },
      {
        notify: false,
      }
    );
  }

  function getMerchantsBySearchTerm(searchTerm) {
    var params = {
      searchTerm: searchTerm,
      offset: 0,
      limit: 10,
    };

    return merchantService.getMerchants(params).then(function(res) {
      if (res && res.data && res.data.merchants) {
        return res.data.merchants.map(function(merchant) {
          return { id: merchant.id, name: merchant.name };
        });
      }
    });
  }

  function calculatePagination() {
    vm.filter.offset = vm.currentPage * vm.filter.limit - vm.filter.limit;
  }

  function pageChanged() {
    vm.calculatePagination();
    vm.getMerchantsByOffset();
  }

  function goToMerchantOverview(id) {
    if (!id) {
      return;
    }
    return $state.go('app.merchant', { merchantId: id });
  }

  function toggleSorting(sortBy) {
    if (sortBy.direction === '' && !sortBy.show) {
      sortBy.show = true;
      sortBy.direction = vm.sortByDirection.DESC;
    } else if (sortBy.direction === vm.sortByDirection.DESC) {
      sortBy.direction = vm.sortByDirection.ASC;
    } else {
      sortBy.direction = '';
      sortBy.show = false;
    }
    vm.filter.sortBy = sortBy.value + sortBy.direction;
    clearSortingArrows(sortBy);
    getMerchants();
  }

  function clearSortingArrows(sortBy) {
    angular.forEach(vm.sortBy, function(order) {
      if (order !== sortBy) {
        order.direction = '';
        order.show = false;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/merchants.overview.controller.js